module.exports = __webpack_public_path__ + "static/keller-smaller-42897e2c1fdcd60d5a7158fd2c0acf24.jpg";